import { render } from "./MailSubView.vue?vue&type=template&id=7fb65ba1&scoped=true&ts=true"
import script from "./MailSubView.vue?vue&type=script&lang=ts"
export * from "./MailSubView.vue?vue&type=script&lang=ts"

import "./MailSubView.vue?vue&type=style&index=0&id=7fb65ba1&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb65ba1"]])

export default __exports__